import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[snAppScrollableItem]',
})
export class SnScrollableItemDirective {
  @Input('snAppScrollableItem') public key: string;
  constructor(private readonly el: ElementRef<HTMLElement>) {}

  public scrollIntoView(): void {
    this.el.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    });
  }
}
